'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _isomorphicFetch = require('isomorphic-fetch');

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

require('react-select/dist/react-select.css');

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _kunaUtils = require('../../utils/kunaUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// We know the max response size is 200 for user/email select2 queries
var MAX_CAMERA_SELECT_QUERY_COUNT = 200;

var CustomerSearch = (_dec = (0, _reactRedux.connect)(function () {
  return {};
}, { pushState: _reactRouterRedux.push }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(CustomerSearch, _Component);

  function CustomerSearch(props) {
    (0, _classCallCheck3.default)(this, CustomerSearch);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CustomerSearch.__proto__ || (0, _getPrototypeOf2.default)(CustomerSearch)).call(this, props));

    _this.state = {
      // multi: true,
      value: []
    };
    _this.onChange = _this.onChange.bind(_this);
    _this.componentWillMount = _this.componentWillMount.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(CustomerSearch, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var query = this.props.location.query;
      var value = [];

      var addEmail = function addEmail(email) {
        return { email: email };
      };

      var addCamera = function addCamera(cam) {
        return { email: cam, serial_number: cam };
      };

      if (query.email) {
        var emails = Array.isArray(query.email) ? query.email : [query.email];
        value = value.concat(emails.map(addEmail));
      }

      if (query.camera) {
        var camera = Array.isArray(query.camera) ? query.camera : [query.camera];
        value = value.concat(camera.map(addCamera));
      }

      this.setState({ value: value });
    }
  }, {
    key: 'onChange',
    value: function onChange(value) {
      this.setState({
        value: value
      });

      // This is how to properly split camera and email -
      // commented out because grabbing just the camera is proving troublesome,
      // instead for right now we will just pull the full user
      // const camera = value.filter(val => val.serial_number).map(val => val.serial_number);
      // const email = value.filter(val => !val.serial_number).map(val => val.email);

      var email = value.map(function (val) {
        return val.serial_number ? val.owner_email : val.email;
      });

      var query = {
        // camera,
        email: email
      };

      this.props.pushState({
        pathname: '/search',
        query: query
      });
    }
  }, {
    key: 'render',
    value: function render() {
      /* eslint-disable react/no-unknown-property */
      return _react2.default.createElement(
        'div',
        { className: 'section' },
        _react2.default.createElement(
          'h3',
          { className: 'section-heading' },
          this.props.label
        ),
        _react2.default.createElement(_reactSelect2.default.Async, {
          multi: true,
          value: this.state.value,
          onChange: this.onChange,
          name: 'query',
          searchPromptText: 'Type to search - minimum 3 characters',
          autoFocus: true,
          onValueClick: this.gotoUser,
          valueKey: 'email',
          labelKey: 'email',
          optionRenderer: this.constructor.renderOptionValues,
          loadOptions: this.constructor.getUsers,
          backspaceRemoves: true,
          placeholder: 'Type a users email or S/N'
        })
      );
      /* eslint-enable react/no-unknown-property */
    }
  }], [{
    key: 'getUsers',
    value: function getUsers(input, callback) {
      if (input.length < 3) {
        callback(null, { options: null });
        return;
      }

      var isDevice = (0, _kunaUtils.isKunaDevice)(input);
      var searchEndPoint = isDevice ? 'cameraslist' : 'useremails';
      var searchString = isDevice ? input.toUpperCase() : input;

      (0, _isomorphicFetch2.default)('api/django/' + searchEndPoint + '/?q=' + encodeURIComponent(searchString), {
        credentials: 'same-origin'
      }).then(function (response) {
        return response.json();
      }).then(function (entriesFound) {
        if (isDevice) {
          // eslint-disable-next-line array-callback-return
          entriesFound.map(function (entry) {
            console.log(entry);
            // eslint-disable-next-line no-param-reassign
            entry.email = entry.serial_number;
          });
        }

        // We know the max response size is 200
        var completeResponse = entriesFound.length >= MAX_CAMERA_SELECT_QUERY_COUNT;

        callback(null, {
          options: entriesFound,
          complete: completeResponse
        });
      });
    }
  }, {
    key: 'renderOptionValues',
    value: function renderOptionValues(option) {
      return _react2.default.createElement(
        'div',
        null,
        option.text
      );
    }
  }]);
  return CustomerSearch;
}(_react.Component), _class2.propTypes = {
  label: _react2.default.PropTypes.string,
  pushState: _react.PropTypes.func.isRequired,
  location: _react.PropTypes.object
}, _temp)) || _class);
exports.default = CustomerSearch;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/CustomerSearch/CustomerSearch.js
 ** module id = 1381
 ** module chunks = 0
 **/